// UserPhonemes.js
import useAuth from "./hooks/useAuth";
import UserPhonemesDynamic from "./UserPhonemesDynamic";
import UserPhonemesSnapshot from "./UserPhonemesSnapshot";

const UserPhonemes = ({ language, date, representation }) => {
    return (
        <div className="w-full">
            {representation === 'Snapshot' ? (
                <UserPhonemesSnapshot language={language} date={date}/>
            ) : (
                <UserPhonemesDynamic language={language} date={date}/>   
            )}
        </div>
    );
}

export default UserPhonemes;